import { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function BillingCallback() {
  const [params] = useSearchParams();
  const ref = params.get("reference") || params.get("trxref");
  const { refresh } = useAuth();
  const [state, setState] = useState({ phase: "checking" });
  const once = useRef(false);
  useEffect(() => {
    if (once.current) return;
    once.current = true;
    if (!ref) { setState({ phase: "failed", text: "No payment reference was returned." }); return; }
    api.post(`/billing/callback?reference=${encodeURIComponent(ref)}`)
      .then(({ data }) => { setState(data.status === "success" ? { phase: "success", text: `Invoice ${data.invoice} is paid. Your subscription is active.` } : { phase: "failed", text: `Payment was not completed (${data.status || "pending"}). You can try again from the billing page.` }); refresh(); })
      .catch((e) => setState({ phase: "failed", text: e.response?.data?.detail || "We could not verify this payment." }));
  }, [ref]); // eslint-disable-line react-hooks/exhaustive-deps
  const Icon = state.phase === "success" ? CheckCircle2 : state.phase === "failed" ? XCircle : Loader2;
  return (
    <div className="mx-auto max-w-md pt-10 fade-up">
      <div className="po-card p-8 text-center" data-testid="billing-callback">
        <Icon className={`mx-auto h-10 w-10 ${state.phase === "success" ? "text-emerald-600" : state.phase === "failed" ? "text-red-600" : "animate-spin text-slate-400"}`} />
        <h1 className="mt-4 text-lg font-semibold text-slate-900" data-testid="billing-callback-title">{state.phase === "success" ? "Payment successful" : state.phase === "failed" ? "Payment not completed" : "Verifying your payment…"}</h1>
        {state.text && <p className="mt-2 text-sm text-slate-600" data-testid="billing-callback-message">{state.text}</p>}
        {state.phase !== "checking" && <Link to="/app/billing" data-testid="billing-callback-back" className="mt-6 inline-block rounded-full bg-[#13294B] px-5 py-2 text-sm font-medium text-white">Back to billing</Link>}
      </div>
    </div>
  );
}
